import { GuidesPayload } from '../model/GuidesModel';
import { GuidesCRUDActions } from '../actions/GuidesCRUDActions';

export type GuidesState = GuidesPayload;

const initial = {
  guides: [],
};

export const guides = (state: GuidesState = initial, action: any) => {
  switch (action.type) {
    case GuidesCRUDActions.retrieveAllSuccess:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
